export default function GanttIcon({ size = 18, strokeWidth = 1.7, ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path d="M4 5.5h4.5" />
      <path d="M4 11.5h7" />
      <path d="M4 17.5h3.5" />
      <rect x="10" y="4" width="8.5" height="3" rx="1" />
      <rect x="13" y="10" width="7" height="3" rx="1" />
      <rect x="9" y="16" width="9.5" height="3" rx="1" />
      <path d="M12 7v3" opacity=".58" />
      <path d="M16.5 13v3" opacity=".58" />
    </svg>
  );
}
